import consumer from "./consumer";

let subscription = null;

export function subscribeToChatUnread(Alpine) {
  if (subscription) return;

  subscription = consumer.subscriptions.create("ChatUnreadChannel", {
    received(data) {
      if (data.type === "unread_count") {
        Alpine.store("chat").unreadCount = data.count;
      }
    }
  });
}

export function unsubscribeFromChatUnread() {
  if (subscription) {
    subscription.unsubscribe();
    subscription = null;
  }
}
